module.exports = __webpack_public_path__ + "static/img/banner_default_5.93ee6dd2.png";